module.exports = __webpack_public_path__ + "img/SNSREGIOBANK.0f23a203.jpg";